export default __webpack_public_path__ + "static/media/hot_bg.5a0b19a2.png";